import classNames from 'classnames'
import { ComponentPropsWithoutRef, forwardRef, useImperativeHandle, useRef } from 'react'

import { useFormControl } from '../FormControl/FormControlContext'

export type TextAreaProps = ComponentPropsWithoutRef<'textarea'>

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { disabled, className, ...props },
  ref
) {
  const innerRef = useRef<HTMLTextAreaElement>(null)
  // Just a trick to use ref while also fowarding
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  useImperativeHandle(ref, () => innerRef.current!)

  const { isInvalid } = useFormControl()

  return (
    <div
      onClick={() => {
        innerRef.current?.focus()
      }}
      className={classNames(
        'mt-1 flex w-full cursor-text rounded-md border px-3 py-2 font-inter text-brand-gray-900 shadow-sm focus-within:ring-1',
        !isInvalid &&
          'border-brand-gray-300 focus-within:border-brand-blue-500 focus-within:ring-brand-blue-500',
        isInvalid &&
          'border-brand-red-300 text-brand-red-900 placeholder-brand-red-300 focus-within:border-brand-red-500  focus-within:ring-brand-red-500',
        disabled && 'cursor-not-allowed border-brand-gray-200 bg-brand-gray-50 text-brand-gray-500',
        className
      )}
    >
      <textarea
        {...props}
        disabled={disabled}
        className={classNames(
          'max-w-full flex-1 border-0 bg-transparent p-0 font-normal placeholder:text-brand-gray-400 focus:outline-none focus:ring-0 disabled:cursor-not-allowed sm:text-sm'
        )}
      />
    </div>
  )
})

export { TextArea }
